var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.mailBody.split('\n')),function(line,lineNumber){return _c('span',{key:lineNumber},[_vm._v(" "+_vm._s(line)),_c('br')])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }